import { TableData } from "../../../components/Table/types";
import { Extraction } from "../../../api/types";
import { timeToText } from "../../../utils/time";
import { typedSxMap } from "../../../utils/typedSxMap";
import { getStatusBadge } from "../../pipelineImports/utils/pipelineImportsTable";

const styles = typedSxMap({
  tooltipWrapper: {
    position: "absolute",
    transform: "translateX(-50%)",
    backgroundColor: "var(--color-background-modal)",
    padding: "var(--m-xxs) var(--m-xs)",
    borderRadius: "var(--border-radius)",
    marginTop: "var(--m-xs)",
    boxShadow: "0 0 0 1px var(--color-border), 0 5px 15px rgba(0, 0, 0, 0.2)",
    maxWidth: "300px",
    zIndex: 1000,
    color: "var(--color-text)",
  },
});

export function extractionsTable(extractions: Extraction[] = []): TableData {
  return extractions.map((e) => {
    return {
      id: e.id,
      Name: e.name,
      Schema: e.schema?.name,
      // Rows: importItem.dst_num_rows,
      // Errors: importItem.dst_num_error_rows,
      Created: timeToText(e.created_at),
      Status: {
        raw: e.status,
        content: getStatusBadge(e.status, e.error as string),
      },
      // _actions: {
      //   raw: e.id,
      //   content: e.status === "review" || e.status === "importing" || e.status === "complete" ? <DownloadExtraction extraction={e} /> : <></>,
      // },
    };
  });
}
